import { Injectable } from '@angular/core';
import { RedatwaterComponentsModule } from '../components/redatwater-components.module';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoadingController, NavController } from '@ionic/angular';
import { AlertService } from './alert.service';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class DivisasService {

  private subscriptionHttp: Subscription = new Subscription();

  public apiUrl = 'http://www.floatrates.com';

  paisSeleccionado: any = {
    id: null,
    pais: null,
    divisa: null,
    idioma: null,
    img: null
  }

  divisa_default = {"code":"COP","alphaCode":"COP","numericCode":"170","name":"Colombian Peso","rate":4399.2867181077,"date":"Wed, 31 May 2023 11:55:01 GMT","inverseRate":0.00022730957631926};

  divisaActual: any = null;
  listaDivisas: any[] = [];

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private loadingCtrl: LoadingController,
  ) {
   // console.log('App -> Divisas!');

  }

  async initDivisas(pais: any) {
    /*
    this.consultarDivisas().then((getDivisas: any) => {
      if (getDivisas) {

        if (pais.id === '1') {

          this.setPaisSeleccionado(pais);
          this.setDivisaActual(this.divisa_default);
          this.auth.appConfig(pais, this.divisa_default);
          console.log('Divisa seleccionada default -> ', this.divisa_default);

        } else {

          let divisaCodeActual = pais.divisa.toLowerCase();
          let divisaActual = getDivisas[divisaCodeActual];
          this.setPaisSeleccionado(pais);
          this.setDivisaActual(divisaActual);
          this.auth.appConfig(pais, divisaActual);
          console.log('Divisa seleccionada otro -> ', divisaActual);

        }

      } else {
        console.log('Seguimiento de errores -> ', getDivisas);
      }
    }).catch((err: any) => {
      console.log('Seguimiento de errores -> ', err);
    });
    */
  }

  async consultarDivisas(): Promise<any> {
    const loading = await this.loadingCtrl.create({
      message: 'Verificando divisas...',
      spinner: 'crescent',
      showBackdrop: true
    });
    loading.present();

    return new Promise((resolve, reject) => {
      /** 
       * En este caso, obtengo el resultado de otra función para usarlo
       * dentro del cuerpo de mi promesa
       */

      const apiPath = this.apiUrl + '/widget/00002077/63c2c4438eb9a4df3a3015f599e49f78/cop.json';
      let getDivisas = this.subscriptionHttp.add(
        this.http.get(apiPath).subscribe((data: any) => {
          if (data) {
            //console.log('Peticion -> lista de divisas: ', data);
            resolve(data);
            loading.dismiss();
          } else {
            console.log('Seguimiento de errores -> ', data);
            resolve(false);
          }
          loading.dismiss();

        }, (err: any) => {
          console.log('Seguimiento de errores -> HTTP: ', err);
          loading.dismiss();
        })
      );

    });

  }

  setListaDivisas(divisas: any) {
    console.log('Actualizar lista Divisas ', divisas);
    if (divisas) {
      this.listaDivisas = divisas;
    } else {
      console.log('Seguimiento de errores -> ', divisas);
    }
  }

  getListaDivisas() {
    console.log('Data lista Divisas');
    return this.listaDivisas;
  }

  setDivisaActual(divisa: any) {
    console.log('Actualizar data Divisa ', divisa);
    if (divisa) {
      this.divisaActual = divisa;

      //this.convertirPrecioDivisa(10000);
    } else {
      console.log('Seguimiento de errores -> ', divisa);
    }
  }

  getDivisaActual() {
    console.log('Data Divisa');
    return this.divisaActual;
  }

  setPaisSeleccionado(pais: any) {
    console.log('Seguimiento -> Establecer pais. ', pais);
    if (pais.id >= 1) {
      this.paisSeleccionado = pais;
    }
  }

  getPaisSeleccionado() {
    return this.paisSeleccionado;
  }

  convertirPrecioDivisa(precio: number) {
    if (precio > 0) {

      if (this.paisSeleccionado.id === '1') { // PAIS SELECCIONADO

        console.log('Divisa Base -> $' + precio + '  ' + this.paisSeleccionado.divisa);
        console.log('Info divisa -> ', this.divisaActual);

        const returnParametros = {
          'precio': precio,
          'precio_divisa': precio
        }

        return returnParametros;

      } else {

        console.log('Info divisa -> ', this.divisaActual);
        let copToUsdRate = this.divisaActual.rate;

        let copAmount = precio;
        let usdAmount = copAmount * copToUsdRate;

        console.log(copAmount + ' COP is equal to ' + usdAmount + ' USD');

        const returnParametros = {
          'precio': copAmount,
          'precio_divisa': usdAmount
        }

        return returnParametros;

      }

    } else {
      console.log('Seguimiento de errores -> ', precio);
    }
  }

}
